import { Component } from '@angular/core';
/**
 * Componente que se muestra cuando hay error 401
 */
@Component({
    selector: 'app-nopagefound',
    templateUrl: './nopagefound.component.html',
    styleUrls: ['./nopagefound.component.scss'],
    standalone: false
})
export class NopagefoundComponent {

}
